import { wordTypeLabel, type WordType } from "../../domain/vocabulary/types.ts";
import type { GroupedWord } from "../../domain/vocabulary/grouping.ts";

export function meaningCountLabel(count: number): string {
  return count === 1 ? "1 meaning" : `${count} meanings`;
}

export function typeChips(types: readonly WordType[]): string[] {
  return types.map(wordTypeLabel);
}

export function groupSubtitle(group: GroupedWord): string {
  return meaningCountLabel(group.meaningCount);
}

export function continueLabel(count: number): string {
  if (count === 0) {
    return "Select a meaning to continue";
  }
  return `Continue with ${count} ${count === 1 ? "meaning" : "meanings"}`;
}

export function saveLabel(count: number): string {
  return `Save ${count} ${count === 1 ? "meaning" : "meanings"} to My Words`;
}
